import { application } from "web-ui/controllers/application"
import Textarea from "web-ui/controllers/textarea"
import TurboStreamButton from "web-ui/controllers/turbo-stream-button"
import DropdownMenu from "web-ui/controllers/dropdown-menu"
import Refresh from "web-ui/controllers/refresh"
import HelpButton from "web-ui/controllers/help-button"
import UserTools from "web-ui/controllers/user-tools"
import ViewFormError from "web-ui/controllers/view-form-error"
import ModalDialog from "web-ui/controllers/modal-dialog"
import ComboBox from "web-ui/controllers/combo-box"
import AsyncComboBox from "web-ui/controllers/async-combo-box"
import ConfirmationField from "web-ui/controllers/confirmation-field"
import Switch from "web-ui/controllers/switch"
import OptionGroup from "web-ui/controllers/option-group"
import FieldPreview from "web-ui/controllers/field-preview"
import CharacterCounter from "web-ui/controllers/character-counter"
import PassiveSubmissionForm from "web-ui/controllers/passive-submission-form"
import ShowPopover from "web-ui/controllers/show-popover"
import Popover from "web-ui/controllers/popover"
import OptionList from "web-ui/controllers/option-list"
import Notices from "web-ui/controllers/notices"
import Notice from "web-ui/controllers/notice"

application.register("textarea", Textarea)
application.register("turbo-stream-button", TurboStreamButton)
application.register("dropdown-menu", DropdownMenu)
application.register("refresh", Refresh)
application.register("help-button", HelpButton)
application.register("user-tools", UserTools)
application.register("view-form-error", ViewFormError)
application.register("modal-dialog", ModalDialog)
application.register("combo-box", ComboBox)
application.register("async-combo-box", AsyncComboBox)
application.register("confirmation-field", ConfirmationField)
application.register("switch", Switch)
application.register("option-group", OptionGroup)
application.register("field-preview", FieldPreview)
application.register("character-counter", CharacterCounter)
application.register("passive-submission-form", PassiveSubmissionForm)
application.register("show-popover", ShowPopover)
application.register("popover", Popover)
application.register("option-list", OptionList)
application.register("notices", Notices)
application.register("notice", Notice)

export { application as stimulusApplication }
